import { HTMLAttributes, JSX } from 'react'
import { DefaultButtonProps } from 'src/components/buttons/default-button/types'
import { cn } from 'src/helpers/cn'
import { VscLoading } from 'react-icons/vsc'

const DefaultButton = ({
  type,
  styleType = 'white',
  className,
  label,
  isLoading,
  disabled,
  leftIcon,
  rightIcon,
  ...props
}: DefaultButtonProps): JSX.Element => {
  const styleMap = (): HTMLAttributes<HTMLButtonElement>['style'] => {
    if (styleType === 'white') {
      return { backgroundColor: 'white', color: '#242424' }
    }

    if (styleType === 'red') {
      return { backgroundColor: '#d52a32', color: '#ffffff' }
    }
  }

  return (
    <button
      type={type || 'button'}
      className={cn(
        'relative rounded-4xl w-full py-4.5 text-center font-semibold overflow-hidden',
        className,
        disabled ? ' pointer-events-none' : 'cursor-pointer',
      )}
      disabled={disabled}
      style={{ ...styleMap() }}
      {...props}
    >
      {isLoading ? (
        <div>
          <span className="opacity-0">
            {leftIcon} {label} {rightIcon}
          </span>
          <VscLoading
            size={40}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 animate-spin"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center">
          {leftIcon}
          <span>{label}</span>
          {rightIcon}
        </div>
      )}

      {(disabled || isLoading) && (
        <div className="left-0 top-0 absolute w-full h-full bg-gray-500/50" />
      )}
    </button>
  )
}

export default DefaultButton
